import { Encoder, MGPOptional, Utils } from '@everyboard/lib';
import { Coord } from '../../jscaip/Coord';
import { Move } from '../../jscaip/Move';
export class SixMove extends Move {
    start;
    landing;
    keep;
    static encoder = Encoder.tuple([MGPOptional.getEncoder(Coord.encoder), Coord.encoder, MGPOptional.getEncoder(Coord.encoder)], (move) => [move.start, move.landing, move.keep], (fields) => SixMove.of(fields[0], fields[1], fields[2]));
    static of(start, landing, keep) {
        return new SixMove(start, landing, keep);
    }
    static ofDrop(landing) {
        return new SixMove(MGPOptional.empty(), landing, MGPOptional.empty());
    }
    static ofTranslation(start, landing) {
        return new SixMove(MGPOptional.of(start), landing, MGPOptional.empty());
    }
    static ofCut(start, landing, keep) {
        return new SixMove(MGPOptional.of(start), landing, MGPOptional.of(keep));
    }
    constructor(start, landing, keep) {
        super();
        this.start = start;
        this.landing = landing;
        this.keep = keep;
        Utils.assert(start.equalsValue(landing) === false, 'Translation cannot be static!');
        Utils.assert(start.isAbsent() || start.equals(keep) === false, 'Cannot keep starting coord, since it will always be empty after move!');
    }
    isDrop() {
        return this.start.isAbsent();
    }
    isCut() {
        return this.keep.isPresent();
    }
    toString() {
        if (this.isDrop()) {
            return 'SixMove(' + this.landing.toString() + ')';
        }
        else if (this.isCut()) {
            return 'SixMove(' + this.start.get().toString() + ' > ' +
                this.landing + ', keep: ' +
                this.keep.get().toString() + ')';
        }
        else {
            return 'SixMove(' + this.start.get().toString() + ' > ' +
                this.landing + ')';
        }
    }
    equals(other) {
        if (this.landing.equals(other.landing) === false) {
            return false;
        }
        if (this.start.equals(other.start) === false) {
            return false;
        }
        return this.keep.equals(other.keep);
    }
}
